<template>
  <md-dialog
    :md-active.sync="isShowModal"
    class="new w-800"
    :md-fullscreen="false"
    @md-opened="scroll('locked')"
    @md-closed="scroll('clear')"
    :md-click-outside-to-close="!isLoading"
  >
    <md-dialog-title>請求先お気に入り編集</md-dialog-title>

    <div class="px-3">
      <InvoiceEdit
        :is-invoice-valid-active="isInvoiceValidActive"
        :parent-form="invoice"
        :is-list-edit="true"
        @setIsInvoiceValid="setIsInvoiceValid"
        @setIsInvoiceValidActive="setIsInvoiceValidActive"
        @setInvoice="changeInvoice"
      />

      <md-dialog-actions>
        <md-button class="md-primary" @click="closed" :disabled="isLoading">
          閉じる
        </md-button>
        <md-button class="md-primary" @click="confirm" :disabled="isLoading">
          登録
        </md-button>
      </md-dialog-actions>
    </div>
  </md-dialog>
</template>

<script>
import Mixin from '@/components/mixin/Mixin'
import _ from 'lodash'
import merge from 'deepmerge'
import InvoiceEdit from '@/components/order/invoice/InvoiceEdit'
import Store from '@/store/index.js'

export default {
  name: 'InvoiceEditModal',
  components: { InvoiceEdit },
  mixins: [Mixin],

  props: {
    /** モーダル表示フラグ */
    isShowModalActive: {
      type: Boolean,
      default: false,
    },

    /** 編集データ */
    editInvoice: {
      type: Object,
      default: null,
    },
  },

  data: () => ({
    /** 編集する請求データ **/
    invoice: null,

    /** 請求先バリデーション発火フラグ **/
    isInvoiceValidActive: false,

    /** モーダル表示フラグ **/
    isShowModal: false,

    /** 請求先バリデーション結果 **/
    isInvoiceValid: false,

    /** 通信中フラグ **/
    isLoading: false,
  }),
  created: function () {},
  methods: {
    /**
     * 請求先バリデーション発火フラグをセットする
     * @param Boolean isInvoiceValid
     */
    setIsInvoiceValidActive(isActive) {
      this.isInvoiceValidActive = isActive
    },
    /**
     * 請求先バリデーション結果フラグをセットする
     * @param Boolean isInvoiceValid
     */
    setIsInvoiceValid(isValid) {
      this.isInvoiceValid = isValid
    },
    /**
     * 編集データをマージする
     * @param invoice invoice
     */
    changeInvoice(invoice) {
      this.invoice = merge(this.invoice, invoice)
    },
    async confirm() {
      this.isInvoiceValidActive = true
      await this.sleep(100)
      if (this.isInvoiceValid) await this.saved()
      this.isInvoiceValidActive = false
      this.spinerOff()
    },
    async saved() {
      this.isLoading = true
      await Store.dispatch('invoice/update', this.invoice).catch((err) => {
        this._alert(err.message, false)
      })
      this.isLoading = false
    },
    /**
     * モーダルを閉じる
     */
    closed() {
      this.isShowModal = false
    },
  },
  watch: {
    /* モーダル表示発火 */
    isShowModalActive(val) {
      if (val) this.isShowModal = true
    },
    /* モーダル表示フラグ */
    isShowModal(val) {
      if (val) this.invoice = _.cloneDeep(this.editInvoice)
      this.$emit('setIsShowModalActive', this.isShowModal)
    },
  },
}
</script>

<style lang="sass" scoped>
@import '../../../assets/css/logico2'
.color-on
  background: $baseBlueColor
  color: #fff
.color-off
  background: #fff
  color: $baseBlackColor
</style>



// WEBPACK FOOTER //
// src/components/order/invoice/InvoiceEditModal.vue